export default __webpack_public_path__ + "7d9f0123adb5eacf33e208015a845d50.svg";